import React, { createContext, useContext, useState } from "react";
import { VideoStatus } from "../services/interface";


export interface Scene {
    sort: string;
    type: string;
    content: any;
}

export interface Video {
  created_at: string;
  id: number;
  ad_id: string;
  owner_id: string;
  reference_id: string;
  state: VideoStatus;
  updated_at: string;
  video_url?: string;
}

export interface VideoContextType {
  videos: Video[];
  setVideos: (videos: Video[]) => void;
}

const VideoContext = createContext<VideoContextType | undefined>(undefined);

export const VideoProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const [videos, setVideos] = useState<Video[]>([]);


  return (
    <VideoContext.Provider
      value={{
        videos,
        setVideos,
      }}
    >
      {children}
    </VideoContext.Provider>
  );
};

export const useVideo = () => {
  const context = useContext(VideoContext);
  if (context === undefined) {
    throw new Error("useVideo must be used within an VideoProvider");
  }
  return context;
};
